import React from 'react'
import firebaseApp from './firebaseApp'
import firebase from 'firebase/app'
import logo from './assets/logo.png'
import './style/events.css'

import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ListItem from "@material-ui/core/ListItem";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Drawer from "@material-ui/core/Drawer";
import clsx from "clsx";

// search user account
import Paper from "@material-ui/core/Paper";
import SearchIcon from "@material-ui/icons/Search";

import { Link } from 'react-router-dom';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

function ListItemLink(props) {
    return <ListItem button component="a" {...props} />;
}

function DisplayHeaderContent(){
    const username = firebaseApp.auth().currentUser.displayName;

    return(
      <>
        <div className="headerContent">
            <img src={logo} className="App-logo" alt="logo" /> 
            <div className="headerTitle">
                Welcome <b>{username}</b> <br/>
                <hr />
                <i>How are you today?</i>
            </div>
        </div>
    </>
    );
}

function MenuLink(){
    const user = firebaseApp.auth().currentUser;    

    if (user != null) {
        var username = user.displayName;
        var email = user.email;
        var photoUrl = user.photoURL;
    }

    const [open, setOpen] = React.useState(false);
    
    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    return(
        <div className="menu"> 
            <Toolbar>
                <IconButton
                    aria-label="menu"
                    onClick={handleDrawerOpen}
                    edge="start"
                    className={clsx(open && "menuHide")}
                >
                    <div className="material-icons menuIcon">menu</div>
                </IconButton>
            </Toolbar>
            <Drawer
                className="menuSection"
                anchor="left"
                onClose={handleDrawerClose}
                open={open}
                classes={{
                    paper: "menuLinkPaper",
                }}
            >
                <div className ="expandMenuSection" >
                    <div className="menuLinkHeader">
                        <IconButton onClick={handleDrawerClose}>
                            <MenuIcon className="menuIconStyle"/>
                        </IconButton>
                    </div>
                    <div className="displayUserInformation">
                        <div className="googleProfilePicSection">
                            <img alt="profile pic icon" src={photoUrl} className="googleProfilePic" />
                            <Link to ="/profile">
                                <div className="btnView"><p>View</p></div>
                            </Link>
                        </div>
                        <div className="loginDetails">
                            <h3 className="username">{username} </h3>
                            <h5 className="emailAddress"><i>{email}</i></h5>
                        </div>
                    </div>
                    <Divider />
                    <List className="listSection">
                        <ListItemLink className="menuLink" href="/dashboard">
                            DASHBOARD
                        </ListItemLink>
                        <ListItemLink className="menuLink" href="/securityEvents">
                            SECURITY EVENTS
                        </ListItemLink>
                        <ListItemLink className="menuLink" href="/emailList">
                            BLACKLIST / WHITELIST
                        </ListItemLink>
                        <ListItemLink className="menuLink" href="/events">
                            YOUR EVENTS
                        </ListItemLink>
                        <ListItemLink className="menuLink" href="/policy">
                            OUR POLICY
                        </ListItemLink>
                        <ListItemLink className="menuLink" href="/newUserSetup">
                            INSTALLATION
                        </ListItemLink>
                    </List>
                </div>
            </Drawer>
        </div>
    );
}

// disabling enter key for search input field
document.addEventListener('keypress', function (e) {
    if (e.keyCode === 13 || e.which === 13) {
        e.preventDefault();
        return false;
    }
});


// props value include setFilteredEvents, refer from events()
function SearchEvents(props){

    const user = firebaseApp.auth().currentUser;    

    if (user != null) {
        var email = user.email;
    }
    
    const [search, SetSearch] = React.useState('');
    const[securityEvent, setSecurityEvents] = React.useState([]);

    const handleChange = event => {
      SetSearch(event.target.value);
    };

    React.useEffect(() => {
        const fetchData = async () =>
        {
            //get database
            const db = firebase.firestore();
            
            var securityEventsRef =  db.collection('securityEvent').doc(email);
            securityEventsRef.get().then(function(doc)
            {
                db.collection('securityEvent').doc(email).onSnapshot(function(doc) 
                {
                    setSecurityEvents(doc.data().predictions)
                })
            })
        }
        fetchData()
        
        props.setFilteredEvents(
            securityEvent.filter(events =>
                events.predict.toLowerCase().includes(search.toLowerCase())
            )
        );
    }, [search, securityEvent]);

    return (
        <>
        <div className="searchSection">
            <b>Search Event : </b>
            <Paper component="form" className="searchField">
                <input
                    className="inputEvent"
                    placeholder="Enter event ....."
                    onChange={handleChange}
                />
                <IconButton
                disabled
                className="btnSearch"
                aria-label="search button"
                >
                    <SearchIcon />
                </IconButton>
            </Paper>
        </div>
        <div>
            <b>[Avaliable security events : Ham / Spam ] </b>
        </div>    
      </>
    );
}

function DisplaySecurityEvent(props){

    return(
        <div className="eventTable" >
        <Table>
          <TableHead>
            <TableRow className="tableRow">
              <TableCell component="th" colspan="4" className="tableHeader"><b>Your Events</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.filteredEvents.reverse().map((row) => (
                <TableRow key={row}>
                    <TableCell align="left">{row.date}</TableCell>
                    <TableCell align="left">{row.time}</TableCell>
                        <TableCell align="left" className="icon">
                            {row.predict === "ham" ? <img src="https://static.wixstatic.com/media/aa8b91_9c37979f2dba4e8d93c748a6b5cce395~mv2.png" className="safeIconStatus" alt="safe icon" /> : 
                            <img src="https://static.wixstatic.com/media/aa8b91_225296f2f317485f8611dc61a4291436~mv2.png" className="unsafeIconStatus" alt="unsafe icon" /> }         
                             {row.predict === "ham" ? <span className="ham"><b> Verification Safe </b></span> : <span className="spam"><b> Verification Failed  </b></span>}               
                        </TableCell>
                        <TableCell align="left">
                            Predicted the sender <b>'{row.senderEmail}'</b> mail as 
                            {row.predict === "ham" ? <span className="ham"><b> Ham </b> </span> : <span className="spam"><b> Spam  </b> </span>} mail.
                        </TableCell>
                </TableRow>
            ))}
          </TableBody>
        </Table>
    </div>
    );
}

function Logout(){
    return(
        <div className="btnLogout">
            <IconButton
            aria-label="exit icon"
            edge="start"
            href="/logout"
            >
                <div className="material-icons exitIcon">
                    exit_to_app
                </div>
            </IconButton>
        </div>
    );
}

function Copyright()
{
    return (
      <>
        {'Copyright © '}
        <Link to="https://isitphishy.wixsite.com/website" target="_blank">
            Phishy
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </>
    );
}

function SecurityEvents() 
{
    const [filteredEvents, setFilteredEvents] = React.useState([]);

    return (
        <>
        <div className="topSectionBackground">
            <div className="topContentBackground">
              <DisplayHeaderContent />
              <MenuLink />
              <Logout />
          </div>
        </div>
        <div className="eventsContent">

            <h1> SECURITY EVENTS </h1>
             {/* pass in current element setFilteredEvents to SearchEvents */}
            <SearchEvents setFilteredEvents={setFilteredEvents}/>
            <DisplaySecurityEvent filteredEvents={filteredEvents} />
        </div>
        <div className="footer">
            <Copyright />
        </div>
        </>
    )
}
export default SecurityEvents;
